import { createGlobalStyle } from 'styled-components';
import { FontFaces } from './fonts';
import { primaryFontFamilyURLs } from './fonts/Primary';
import { secondaryFontFamilyURLs } from './fonts/Secondary';
export const GlobalFonts = createGlobalStyle `
  ${FontFaces}
`;
export const fontAddiFamilyURLs = [
    ...primaryFontFamilyURLs,
    ...secondaryFontFamilyURLs
];
//# sourceMappingURL=index.js.map